const toggleHandler = item => {
  document.querySelector(item).classList.toggle('is-active');
}

export default toggleHandler;